/**
 * The interface's line colour follows the game's outline colour
 * (Settings.outlineColor): every stylesheet derives its lines from --line-rgb.
 */
export function applyLineColour(color: number): void {
  document.documentElement.style.setProperty('--line-rgb', `${(color >> 16) & 255} ${(color >> 8) & 255} ${color & 255}`);
}
